import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import Gikam from 'gikam';
export var PageEditAuthorityUtils = /*#__PURE__*/function () {
  function PageEditAuthorityUtils() {
    _classCallCheck(this, PageEditAuthorityUtils);
  }

  _createClass(PageEditAuthorityUtils, null, [{
    key: "getAuthorityVisible",
    value: function getAuthorityVisible(options) {
      var _options$visibleRoles;

      if (!options || !options.id || !Gikam.loginUser) {
        return true;
      }

      if (Gikam.loginUser.isAdmin) {
        return true;
      }

      if (Gikam.isEmpty(options.visibleRoles)) {
        return true;
      }

      if ((_options$visibleRoles = options.visibleRoles) !== null && _options$visibleRoles !== void 0 && _options$visibleRoles.some(function (roleId) {
        return Gikam.loginUser.roles.includes(roleId);
      })) {
        return true;
      }

      return false;
    }
  }, {
    key: "getAuthorityEditable",
    value: function getAuthorityEditable(options) {
      var _options$editRoles;

      if (!options || !options.id || !Gikam.loginUser) {
        return true;
      }

      if (Gikam.loginUser.isAdmin) {
        return true;
      }

      if (Gikam.isEmpty(options.editRoles)) {
        return true;
      }

      if ((_options$editRoles = options.editRoles) !== null && _options$editRoles !== void 0 && _options$editRoles.some(function (roleId) {
        return Gikam.loginUser.roles.includes(roleId);
      })) {
        return true;
      }

      return false;
    }
  }, {
    key: "initAuthority",
    value: function initAuthority(itemList) {
      for (var i = itemList.length - 1; i > -1; i--) {
        var item = itemList[i]; // 可见权限

        if (this.getAuthorityVisible(item) === false) {
          itemList.splice(i, 1);
          return;
        } // 可编辑权限


        if (PageEditAuthorityUtils.getAuthorityEditable(item) === false) {
          item.readonly = true;
          item.editor = false;
        }
      }
    }
  }]);

  return PageEditAuthorityUtils;
}();